import { Modal } from '@smartgift/frontend-toolkit';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { DigitalWrapper } from '@hero/organisms';

import * as S from './style';

export const DigitalWrapperModal = ({
  branding,
  isOpen,
  setIsOpen,
  onUpdateData,
  isUpdating,
  children,
  defaultOccasion
}) => {
  const { t } = useTranslation();
  const closeModalHandler = () => {
    setIsOpen(false);
  };

  return (
    <S.DigitalWrapperModal>
      {children}
      <Modal
        isOpen={isOpen}
        onRequestClose={closeModalHandler}
        title={t('editYourDigitalGiftWrap')}
        primaryButtonProps={{ onClick: closeModalHandler }}
        size="md"
      >
        <S.DigitalWrapperModalBody>
          <DigitalWrapper
            branding={branding}
            isUpdating={isUpdating}
            onUpdateData={branding => {
              onUpdateData({ branding });
            }}
            defaultOccasion={defaultOccasion}
          />
        </S.DigitalWrapperModalBody>
      </Modal>
    </S.DigitalWrapperModal>
  );
};
